import { Investment } from "../store/investment/types";
import { Property } from "../store/property/types";
import { User } from "../store/user/types";

export const getStoragePersonalDetails = (): User => {
  const storageUserDetails = localStorage.getItem("userDetails");
  return storageUserDetails
    ? new User(JSON.parse(storageUserDetails))
    : new User(null);
};

export const getStorageCurrentShare = (): Investment => {
  const storageShares = localStorage.getItem("currentShare");
  return storageShares
    ? new Investment(JSON.parse(storageShares))
    : new Investment(null);
};

export const getStorageCurrentProperties = () => {
  const storageProperties = localStorage.getItem("properties");
  if (storageProperties) {
    return JSON.parse(storageProperties) as Property[];
  }
  return [] as Property[];
};

export const getStorageToken = () => {
  return localStorage.getItem('token') || "";
}